import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=26c5b6e2&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c5b6e2",
  null
  
)

export default component.exports